import { observable, action } from 'mobx';

export class LocationMapStore{

    @observable locationInfos = [];//位置信息
    cancelEvent = null;


    setCancelEvent = (fun) => {
        this.cancelEvent = fun;
    }


    setLocationInfos = (locationInfos) => {
        this.locationInfos = locationInfos;
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/locationMap.js